@if (fieldSet.includes(ServiceDataFields.PriorScreeningTest)) {
  <ng-container formGroupName="priorScreeningTest">
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <div class="row align-items-center">
          <div class="col-12 col-sm-4 mb-1">
            <label for="priorScreeningTest">{{
              'serviceData.form.priorScreeningTest' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-8">
            <app-select
              appInputValidationStatus
              class="w-100"
              id="priorScreeningTest"
              formControlName="priorScreeningTestType"
              [attr.data-cy]="ServiceDataFields.PriorScreeningTest + '-select'"
              [placeholder]="
                'serviceData.form.placeholders.priorScreeningTest' | translate
              "
            >
              @for (type of Object.keys(PriorScreeningTestType); track type) {
                <app-select-option
                  [value]="type"
                  [label]="
                    'serviceData.form.priorScreeningTestType.' + type
                      | translate
                  "
                />
              }
            </app-select>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-8">
            <app-validation-error
              for="priorScreeningTestType"
              translations="validation.generic"
              [attr.data-cy]="
                ServiceDataFields.PriorScreeningTest + '-validation-error'
              "
            ></app-validation-error>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 mb-3" formGroupName="firstTRisks">
        <div class="row align-items-center">
          <div class="col-12 col-sm-4 mb-1">
            <label for="firstT21Risk">{{
              'serviceData.form.firstT21Risk' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-8">
            <input
              class="form-control"
              type="number"
              formControlName="t21Risk"
              id="firstT21Risk"
              appInputValidationStatus
              data-cy="FirstT21Risk-input"
              [placeholder]="
                'serviceData.form.placeholders.firstT21Risk' | translate
              "
            />
          </div>
        </div>
        <div class="row mb-3 justify-content-end">
          <div class="col-12 col-sm-8">
            <app-validation-error
              for="t21Risk"
              translations="serviceData.form.validation.trisomy"
              data-cy="FirstT21Risk-validation-error"
            ></app-validation-error>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col-12 col-sm-4 mb-1">
            <label for="firstT18Risk">
              {{ 'serviceData.form.firstT18Risk' | translate }}
            </label>
          </div>
          <div class="col-12 col-sm-8">
            <input
              class="form-control"
              type="number"
              formControlName="t18Risk"
              id="firstT18Risk"
              appInputValidationStatus
              data-cy="FirstT18Risk-input"
              [placeholder]="
                'serviceData.form.placeholders.firstT18Risk' | translate
              "
            />
          </div>
        </div>
        <div class="row mb-3 justify-content-end">
          <div class="col-12 col-sm-8">
            <app-validation-error
              for="t18Risk"
              translations="serviceData.form.validation.trisomy"
              data-cy="FirstT18Risk-validation-error"
            ></app-validation-error>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-12 col-sm-4 mb-1">
            <label for="firstT13Risk">{{
              'serviceData.form.firstT13Risk' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-8">
            <input
              class="form-control"
              type="number"
              formControlName="t13Risk"
              id="firstT13Risk"
              appInputValidationStatus
              data-cy="FirstT13Risk-input"
              [placeholder]="
                'serviceData.form.placeholders.firstT13Risk' | translate
              "
            />
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-8">
            <app-validation-error
              for="t13Risk"
              translations="serviceData.form.validation.trisomy"
              data-cy="FirstT13Risk-validation-error"
            ></app-validation-error>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mb-3" formGroupName="secondTRisks">
        <div class="row align-items-center">
          <div class="col-12 col-sm-4 mb-1">
            <label for="secondT21Risk">{{
              'serviceData.form.secondT21Risk' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-8">
            <input
              class="form-control"
              type="number"
              formControlName="t21Risk"
              id="secondT21Risk"
              appInputValidationStatus
              data-cy="SecondT21Risk-input"
              [placeholder]="
                'serviceData.form.placeholders.secondT21Risk' | translate
              "
            />
          </div>
        </div>
        <div class="row mb-3 justify-content-end">
          <div class="col-12 col-sm-8">
            <app-validation-error
              for="t21Risk"
              translations="serviceData.form.validation.trisomy"
              data-cy="SecondT21Risk-validation-error"
            ></app-validation-error>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-12 col-sm-4 mb-1">
            <label for="secondT18Risk">{{
              'serviceData.form.secondT18Risk' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-8">
            <input
              class="form-control"
              type="number"
              formControlName="t18Risk"
              id="secondT18Risk"
              appInputValidationStatus
              data-cy="SecondT18Risk-input"
              [placeholder]="
                'serviceData.form.placeholders.secondT18Risk' | translate
              "
            />
          </div>
        </div>
        <div class="row mb-3 justify-content-end">
          <div class="col-12 col-sm-8">
            <app-validation-error
              for="t18Risk"
              translations="serviceData.form.validation.trisomy"
              data-cy="SecondT18Risk-validation-error"
            ></app-validation-error>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-12 col-sm-4 mb-1">
            <label for="secondT13Risk">{{
              'serviceData.form.secondT13Risk' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-8">
            <input
              class="form-control"
              type="number"
              formControlName="t13Risk"
              id="secondT13Risk"
              appInputValidationStatus
              data-cy="SecondT13Risk-input"
              [placeholder]="
                'serviceData.form.placeholders.secondT13Risk' | translate
              "
            />
          </div>
        </div>
        <div class="row mb-3 justify-content-end">
          <div class="col-12 col-sm-8">
            <app-validation-error
              for="t13Risk"
              translations="serviceData.form.validation.trisomy"
              data-cy="SecondT13Risk-validation-error"
            ></app-validation-error>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
}
